<div [ngStyle]="{'background-color': color?.hex, 'color' : color?.text}">

    <div [ngStyle]="{'max-width': width, 'padding' : padding + ' ' + sidePadding}">
        <ng-content></ng-content>
    </div>

</div>